// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.customModal {
background-color: black !important;
/* border: 2px solid white; */
/* height: 100% !important; */
}

.image-modal{
    width: 60%;
    height: 90%;
    max-width: 350px;
    max-height: 600px;
}


.content{
    width: 100%;
    height: 100px;
    overflow: hidden;
}

.react-responsive-modal-modal {
    max-width: 80vw !important;
}

@media screen and (max-width: 800px) {
        .react-responsive-modal-modal {
                max-width: 95vw !important;
        }
    }

#modalLG{
        max-width: 80vw !important;
}

.react-responsive-modal-container.react-responsive-modal-containerCenter{
        display: flex;  
    justify-content: center;
    align-items: center;
}

.button-next{
    opacity: 0;
}

.slider-image:hover{
    /* background-color: rgba(0, 0, 0, 0.3); */
    
}

.background{
   
}

.slider-image:hover .button-next {
  opacity: 1; /* Tombol muncul saat di-hover */
	 animation: puff-in-top 0.5s cubic-bezier(0.470, 0.000, 0.745, 0.715) both;
}

.slider-image:hover .background{
	animation: puff-in-top 0.5s cubic-bezier(0.470, 0.000, 0.745, 0.715) both;
    background-color: rgba(0, 0, 0, 0.45);
}
  @keyframes puff-in-top {
    0% {
      /* -webkit-transform: scale(2);
              transform: scale(2);
      -webkit-transform-origin: 50% 0%;
              transform-origin: 50% 0%; */
      filter: blur(4px);
      opacity: 0;
    }
    100% {
      /* -webkit-transform: scale(1);
              transform: scale(1);
      -webkit-transform-origin: 50% 0%;
              transform-origin: 50% 0%; */
      filter: blur(0px);
      opacity: 1;
    }
  }
  `, "",{"version":3,"sources":["webpack://./src/view/css/modal.css"],"names":[],"mappings":";AACA;AACA,kCAAkC;AAClC,6BAA6B;AAC7B,6BAA6B;AAC7B;;AAEA;IACI,UAAU;IACV,WAAW;IACX,gBAAgB;IAChB,iBAAiB;AACrB;;;AAGA;IACI,WAAW;IACX,aAAa;IACb,gBAAgB;AACpB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;QACQ;gBACQ,0BAA0B;QAClC;IACJ;;AAEJ;QACQ,0BAA0B;AAClC;;AAEA;QACQ,aAAa;IACjB,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,0CAA0C;;AAE9C;;AAEA;;AAEA;;AAEA;EACE,UAAU,EAAE,gCAAgC;EAErC,yEAAyE;AAClF;;AAEA;CAEC,yEAAyE;IACtE,qCAAqC;AACzC;EAuBE;IACE;MACE;;;yCAGmC;MAE3B,iBAAiB;MACzB,UAAU;IACZ;IACA;MACE;;;yCAGmC;MAE3B,iBAAiB;MACzB,UAAU;IACZ;EACF","sourcesContent":["\n.customModal {\nbackground-color: black !important;\n/* border: 2px solid white; */\n/* height: 100% !important; */\n}\n\n.image-modal{\n    width: 60%;\n    height: 90%;\n    max-width: 350px;\n    max-height: 600px;\n}\n\n\n.content{\n    width: 100%;\n    height: 100px;\n    overflow: hidden;\n}\n\n.react-responsive-modal-modal {\n    max-width: 80vw !important;\n}\n\n@media screen and (max-width: 800px) {\n        .react-responsive-modal-modal {\n                max-width: 95vw !important;\n        }\n    }\n\n#modalLG{\n        max-width: 80vw !important;\n}\n\n.react-responsive-modal-container.react-responsive-modal-containerCenter{\n        display: flex;  \n    justify-content: center;\n    align-items: center;\n}\n\n.button-next{\n    opacity: 0;\n}\n\n.slider-image:hover{\n    /* background-color: rgba(0, 0, 0, 0.3); */\n    \n}\n\n.background{\n   \n}\n\n.slider-image:hover .button-next {\n  opacity: 1; /* Tombol muncul saat di-hover */\n  -webkit-animation: puff-in-top 0.5s cubic-bezier(0.470, 0.000, 0.745, 0.715) both;\n\t        animation: puff-in-top 0.5s cubic-bezier(0.470, 0.000, 0.745, 0.715) both;\n}\n\n.slider-image:hover .background{\n    -webkit-animation: puff-in-top 0.5s cubic-bezier(0.470, 0.000, 0.745, 0.715) both;\n\tanimation: puff-in-top 0.5s cubic-bezier(0.470, 0.000, 0.745, 0.715) both;\n    background-color: rgba(0, 0, 0, 0.45);\n}\n\n\n@-webkit-keyframes puff-in-top {\n    0% {\n      /* -webkit-transform: scale(2);\n              transform: scale(2);\n      -webkit-transform-origin: 50% 0%;\n              transform-origin: 50% 0%; */\n      -webkit-filter: blur(4px);\n              filter: blur(4px);\n      opacity: 0;\n    }\n    100% {\n      /* -webkit-transform: scale(1);\n              transform: scale(1);\n      -webkit-transform-origin: 50% 0%;\n              transform-origin: 50% 0%; */\n      -webkit-filter: blur(0px);\n              filter: blur(0px);\n      opacity: 1;\n    }\n  }\n  @keyframes puff-in-top {\n    0% {\n      /* -webkit-transform: scale(2);\n              transform: scale(2);\n      -webkit-transform-origin: 50% 0%;\n              transform-origin: 50% 0%; */\n      -webkit-filter: blur(4px);\n              filter: blur(4px);\n      opacity: 0;\n    }\n    100% {\n      /* -webkit-transform: scale(1);\n              transform: scale(1);\n      -webkit-transform-origin: 50% 0%;\n              transform-origin: 50% 0%; */\n      -webkit-filter: blur(0px);\n              filter: blur(0px);\n      opacity: 1;\n    }\n  }\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
